<template functional v-slot:[`label`]>
    <v-row>
        <v-col cols="12" sm="2">
            <span class="font-weight-medium">{{ props.name }}</span>
        </v-col>
        <v-col cols="12" sm="10">
            <div v-html="props.value"></div>
        </v-col>
    </v-row>
</template>
<script>
export default {
    functional: true,
    props: {
        name: String,
        value: [String, Number, Boolean],
    },
}
</script>
